export const SHADOW = {
  HOVER: {
    CARD_WITH_NUMBER: '0 4px 8px 0 #99999933',
    SERVICE_CARD: '0 2px 12px 0 #53535326',
    FILTER: '0 10px 12px 0 #23232390',
  },
};
